import type { ReactNode } from "react";
import { Flex, Icon } from "@chakra-ui/react";
import type { APIListingEvent } from "models/types/api-listing";
import PersonIcon from "assets/icons/medium/person.svg?react";
import { CardRecordMeta } from "components/cards/card-record-meta";
import { EventOrFeedbackTypeTag } from "modules/vendor-portal/components/event-or-feedback-type-tag";
import { FooterText } from "modules/vendor-portal/screens/overview/components/feedback/footer/footer-text";
import { generateSingularLabel } from "utils/generate-singular-label";

type EventFooterProps = {
  event: NonNullable<APIListingEvent>;
  children?: ReactNode;
};
export function EventFooter({
  event,
  event: { feedback },
  children,
}: EventFooterProps) {
  return (
    <CardRecordMeta>
      <EventOrFeedbackTypeTag type={feedback?.type || event.type} />
      {feedback?.agent || event.agent ? (
        <FooterText
          whiteSpace={"normal"}
          text={`Hosted by ${feedback?.agent?.name ?? event.agent?.name}`}
        />
      ) : null}
      {event.attendee_count ? (
        <Flex direction={"row"} align={"center"} gap={1}>
          <Icon as={PersonIcon} boxSize={"12px"} />
          <FooterText
            text={`${event.attendee_count} ${generateSingularLabel(
              "attendees",
              event.attendee_count ?? 0,
            )}`}
          />
        </Flex>
      ) : null}

      {children}
    </CardRecordMeta>
  );
}
